// extracted by css-extract-rspack-plugin
export default {"root":"Whec3l","tips":"iwWFlO"};